import EnvironmentOutlined from '@ant-design/icons/EnvironmentOutlined';
import GlobalOutlined from '@ant-design/icons/GlobalOutlined';
import ClusterOutlined from '@ant-design/icons/ClusterOutlined';
import ApartmentOutlined from '@ant-design/icons/ApartmentOutlined';
import NodeIndexOutlined from '@ant-design/icons/NodeIndexOutlined';
import BorderOutlined from '@ant-design/icons/BorderOutlined';
import StopOutlined from '@ant-design/icons/StopOutlined';
import DeploymentUnitOutlined from '@ant-design/icons/DeploymentUnitOutlined';
import { t } from 'i18n';

const location = {
  id: 'group-location',
  title: t('Geography'),
  type: 'group',
  children: [
    { id: 'governorates', title: t('Governorates'), type: 'item', url: '/location/governorates', icon: GlobalOutlined },
    { id: 'cities', title: t('Cities'), type: 'item', url: '/location/cities', icon: ApartmentOutlined },
    { id: 'districts', title: t('Districts'), type: 'item', url: '/location/districts', icon: EnvironmentOutlined },
    { id: 'zones', title: t('Zones'), type: 'item', url: '/location/zones', icon: ClusterOutlined },
    { id: 'district-matrix', title: t('District Matrix'), type: 'item', url: '/location/district-matrix', icon: NodeIndexOutlined },
    { id: 'zone-matrix', title: t('Zone Matrix'), type: 'item', url: '/location/zone-matrix', icon: DeploymentUnitOutlined },
    { id: 'district-polygons', title: t('District Polygons'), type: 'item', url: '/location/district-polygons', icon: BorderOutlined },
    {
      id: 'delivery-restrictions',
      title: t('Delivery Restrictions'),
      type: 'item',
      url: '/location/delivery-restrictions',
      icon: StopOutlined
    }
  ]
};

export default location;
